import "./SingleChannel.css";
import Container from "react-bootstrap/Container";

import ContentWrapper from "../Atomics/ContentWrapper/ContentWrapper";

import SingleChannelHero from "./SingleChannelHero";
import SingleChannelNav from "./SingleChannelNav";
import ChannelVideos from "./ChannelVideos";
import { useEffect } from "react";
import { setSelectedMeta } from "../../action/MetaAction";
import { useDispatch } from "react-redux";
import DefaultImg from '../../img/site.jpg'

const Countries = () => {
	const dispatch = useDispatch();

	const Metadispatch = (title, desc, image) => {
		dispatch(
			setSelectedMeta(`Tvzinos | ${title}`, desc, image)
		).then((res) => {
			// setSelectedMeta(res.data.news.title, res.data.news.details, res.data.news.image)
			console.log(res);
		})
	}  

	useEffect(() => {
		window.scrollTo(0, 0)
		Metadispatch('World', 'Watch the world FREE ', DefaultImg)
	}, [])
	return (
		<>
			<ContentWrapper className="single-channel-page">
				{/* <SingleChannelNav /> */}
				<Container fluid >
					<ChannelVideos />
				</Container>
			</ContentWrapper>

		</>
	);
};

export default Countries;
